// extracted by mini-css-extract-plugin
export var modal = "_53-0";